'use client';

import { getENV } from '../../../utils/env';
import { CrossDomainScript, OneTrustScript, OptanonScript } from './components';
import { useOneTrustParams } from './hooks';

export const OneTrustLegacy = ({ customerKey }: { customerKey: string | undefined }) => {
    const {
        NEXT_PUBLIC_ONETRUST_US_DOMAIN_SCRIPT_ID,
        NEXT_PUBLIC_ONETRUST_CA_DOMAIN_SCRIPT_ID,
        NEXT_PUBLIC_ONETRUST_ENABLED,
        NEXT_PUBLIC_LOCALE,
    } = getENV();
    const isCA = NEXT_PUBLIC_LOCALE === 'en-CA';
    const oneTrustDomainScriptID = isCA
        ? NEXT_PUBLIC_ONETRUST_CA_DOMAIN_SCRIPT_ID
        : NEXT_PUBLIC_ONETRUST_US_DOMAIN_SCRIPT_ID;

    const { token } = useOneTrustParams({ customerKey });

    const isCrossDomainScriptEnabled = customerKey && oneTrustDomainScriptID && NEXT_PUBLIC_ONETRUST_ENABLED;

    return (
        <>
            {isCrossDomainScriptEnabled && Boolean(token) && (
                <CrossDomainScript customerKey={customerKey} token={token} />
            )}
            <OneTrustScript scriptId={oneTrustDomainScriptID} />
            <OptanonScript />
        </>
    );
};
